// export const URL_API = "http://localhost:4032/api/";

export const URL_API = process.env.REACT_APP_URL_API
export const URL_API_ICP =
  process.env.REACT_APP_URL_API_ICPA || 'https://icpaapi.dev.mytraining.center/'
